export default {
  "can-edit-profile": {
    label: "Puede editar su perfil",
    key: "can-edit-profile",
  },
  "models-stars-limit": {
    label: "Tiene acceso a modelos con un rango de estrellas inferior o igual a:",
    key: "models-stars-limit",
    roles: ["monitor"],
    hasValue: true,
    valueType: "number",
  },
  "acccess-to-novelties": {
    label: "El monitor Tiene Acceso a crear novedades",
    key: "acccess-to-novelties",
    roles: ["monitor"],
    hasValue: false,
    valueType: "number",
  },
  "assign-permission-free-private": {
    label: "Solo puede gestionar modelos Free o Privadas",
    key: "assign-permission-free-private",
    roles: ["coordinator"],
  },
  "see-from": {
    label: "Este usuario podra ver registros desde la fecha: ",
    key: "see-from",
    roles: ["monitor"],
    hasValue: true,
    valueType: "Date",
  },
};

export const allowRoutesByRol = {
  coordinator: {
    menu: [1, 2, 4, 5, 6, 7, 8],
    allowRoutes: ["/", "/main", "/newsList", "/account", "/2FA", "/availability", "/users", "/guideline", "/operation", "/occupation", "/helpdesk", "/competition", "/bonds"],
  },
  monitor: { menu: [1, 2, 4, 6], allowRoutes: ["/", "/main", "/newsList", "/account", "/users", "/operation", "/occupation", "/competition", "/helpdesk"] },
  model: { menu: [1, 4, 6, 7], allowRoutes: ["/", "/main", "/newsList", "/account", "/helpdesk", "/competition", "/bonds"] },
};
